import { deviceManager } from '@hid/device/device_manager'
import type { KIO, KK, Layout, MacroType, Record, SetMagnetSenior } from '../../define/define'

const assignLayoutOverlay = (layout: Layout, overlay: Partial<Layout>) => {
  if (overlay.KeyMap !== undefined) {
    layout.KeyMap = overlay.KeyMap
  }
  if (overlay.KeyMapModifier !== undefined) {
    layout.KeyMapModifier = overlay.KeyMapModifier
  }
  if (overlay.Magenet !== undefined) {
    layout.Magenet = overlay.Magenet
  }
  if (overlay.Macros !== undefined) {
    layout.Macros = overlay.Macros
  }
  if (overlay.MacroType !== undefined) {
    layout.MacroType = overlay.MacroType
  }
  if (overlay.KeyMapFire !== undefined) {
    layout.KeyMapFire = overlay.KeyMapFire
  }
}

export async function applyDeviceFnLayoutOverlay(layout: Layout): Promise<void> {
  try {
    const overlay = await deviceManager.deviceDriver.getFnLayoutOverlay()
    if (overlay !== undefined) {
      assignLayoutOverlay(layout, overlay)
      return
    }

    const keyMap = await deviceManager.deviceDriver.getFnKeyMapOverlay()
    keyMap?.forEach((vk, kk) => {
      layout.KeyMap.set(kk, vk)
    })
  } catch (error) {
    console.warn('apply device fn key map overlay failed', error)
  }
}

export async function applyDeviceKeyLayoutOverlay(layout: Layout) {
  try {
    const overlay = await deviceManager.deviceDriver.getKeyLayoutOverlay()
    if (overlay === undefined) {
      return
    }

    assignLayoutOverlay(layout, overlay)
  } catch (error) {
    console.warn('apply device key layout overlay failed', error)
  }
}
